import keyBy from 'lodash/keyBy';
import mapValues from 'lodash/mapValues';

import { IBookingPartnersHashMap } from './types';

export const keyValueArrayToHashMap = (
  data: IBookingPartnersHashMap[] | undefined,
  keyName: string,
  valueName: string,
) => mapValues(keyBy(data, keyName), valueName);

export default { keyValueArrayToHashMap };
